import { UPDATE_APP_DATA } from 'constants/action_types'
import { selectCurrentTotalPerCycle } from 'ducks/billing'
import {
  SHOPIFY_BILLING_CONFIRMED,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from 'ducks/billing/types'
import { FETCH_CURRENT_USER_SUCCESS } from 'ducks/currentUser/types'
import { createActionTypeReducer } from 'util/reducers'
import { dataLayer } from 'util/tracking'

const identifyUser = (_, { data: { currentUser: user } }) => {
  dataLayer({ event: 'identifyUser', userId: user.id })
}

const trackConversion = (_, __, sharedState) => {
  const total = selectCurrentTotalPerCycle(sharedState)
  const account = sharedState.app.account
  const first = !account?.preferences?.usage_onboarding?.activated_subscription
  dataLayer({
    event: 'billingChange',
    accountId: account.id,
    externalAccountId: sharedState.billing.externalAccountId,
    provider: sharedState.billing.provider,
    billingCycle: sharedState.billing.billing_cycle,
    total,
    isFirstConversion: first,
  })
}

export default createActionTypeReducer(
  {
    [UPDATE_APP_DATA]: identifyUser,
    [FETCH_CURRENT_USER_SUCCESS]: identifyUser,
    [SHOPIFY_BILLING_CONFIRMED]: trackConversion,
    [UPDATE_SUBSCRIPTION_SUCCESS]: (draftState, payload, sharedState) => {
      // NOTE (jscheel): Shopify fires this action, but we don't actually know
      // that the customer has successfully set up a new subscription yet,
      if (sharedState.billing.provider === 'shopify') return draftState
      return trackConversion(draftState, payload, sharedState)
    },
  },
  {}
)
